// extracted by mini-css-extract-plugin
export var addinsBody = "rRiiv";
export var addinsHeader = "RbDKq";
export var addinsTitle = "SHmTv";
export var container = "wdWLd";
export var copilotChatBody = "pMMtq";
export var copilotChatHeader = "ejbTF";
export var editorPane = "goYkZ";
export var helpBody = "tMEMy";
export var rolloutOverridesBody = "nC39a";
export var tipsBody = "PoXtu";